import React, { useState, useEffect } from 'react'
import styled from 'styled-components';
import * as Yup from 'yup';
import "yup-phone";
import { AlternateEmail, Call, Key } from 'styled-icons/material';
import { MDBRow } from 'mdb-react-ui-kit';

import { EditableContent } from '../components/content/editable-content.component';
import {
    ClientDataApi, ClientContactDictionaryApi, ClientConsentApi
} from '../api/api-client';
import { AddContact } from '../components/content/add-contact.component';
import {
    ClientAddresses, ClientCodeAndName, LabelAndValueContent
} from '../components/content/key-value-content.component';
import { ChangePassword } from '../components/content/change-password.component';
import { ConsentContent } from '../components/content/consent-content.component';
import { PrimaryBtn, SecondaryBtn } from '../components/content/buttons.component';
import {
    CommonCol, CommonColCard6, LoadingDataWrapper
} from '../components/content/mdb-custom.component';
import { PasswordPolicyNote } from '../components/content/auth-helpers.component';

const FIELD_EMPTY = 'Pole nie może być puste. ';
const FIELD_EMAIL = 'Proszę podać poprawny adres email. ';
const FIELD_PHONE = 'Proszę podać poprawny numer telefonu. ';

const ButtonWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 1rem 0;
  gap: 0.5rem;

  @media(min-width: 1000px) {
      gap: 1rem;
  }
`

export const AccountPage = () => {
  // client data
  const [data, setData] = useState({});

  // fetched client contact data
  const [clientContact, setClientContact] = useState({});

  // consents data
  const [consents, setConsents] = useState({})

  // fetch again when adding or editing succeds
  const [refetch, setRefetch] = useState(false)

  // manage displaying forms
  const [show, setShow] = useState('')

  const [feedback, setFeedback] = useState('');

  // https://www.npmjs.com/package/yup-phone
  const phoneSchema = Yup.string().phone('PL', true, FIELD_PHONE).required(FIELD_EMPTY);
  const mailSchema = Yup.string().email(FIELD_EMAIL).required(FIELD_EMPTY);
  const stringSchema = Yup.string().required(FIELD_EMPTY);
  let phones = [], emails = [];

  useEffect(() => {
    const fetchData = async () => {
      const result = await new ClientDataApi().get();
      setData(result.data);
    }
    fetchData();
  }, [refetch])

  useEffect(() => {
    const fetchData = async () => {
      const result = await new ClientContactDictionaryApi().get();
      setClientContact(result.data);
    }
    fetchData();
  }, [])

  useEffect(() => {
    const fetchData = async () => {
      const result = await new ClientConsentApi().get();
      setConsents(result.data);
    }
    fetchData();
  }, [])

  if (Object.keys(data).length !== 0) {
    phones = data.clientcontact_set.map((element) => {
      if (!element.is_mail) {
        return <EditableContent
          key={element.id}
          id={element.id}
          content={[element.name, element.contact]}
          validation={phoneSchema}
          refetch={refetch}
          setRefetch={setRefetch}
        />
      } else return null;
    })

    emails = data.clientcontact_set.map((element) => {
      if (element.is_mail) {
        return <EditableContent
          key={element.id}
          id={element.id}
          content={[element.name, element.contact]}
          validation={mailSchema}
          refetch={refetch}
          setRefetch={setRefetch} />
      } else return null;
    })
  }

  let clientLogin = sessionStorage.getItem('login');

  return (
      <>
      <MDBRow className='mt-5 mt-lg-0 pt-5 pt-lg-0 gx-5 align-items-stretch'>
          <CommonColCard6 cardTitle='Moje dane'>
              <LoadingDataWrapper waitingFor={data}>
                <ClientCodeAndName client_details={data} />
              </LoadingDataWrapper>
          </CommonColCard6>
          <CommonColCard6 cardTitle='Adresy'>
              <LoadingDataWrapper waitingFor={data}>
                <ClientAddresses client_details={data} />
              </LoadingDataWrapper>
          </CommonColCard6>
      </MDBRow>
      <MDBRow className='gx-5 align-items-stretch'>
          <CommonColCard6 cardTitle='Dane kontaktowe'>
              <LoadingDataWrapper waitingFor={data}>
                  {phones}
                  {emails}

                  <ButtonWrapper>
                      <SecondaryBtn onClick={() => {
                          if (show !== 'email') {
                            setShow('email');
                          } else {
                            setShow('');
                          }
                          }}>
                          <AlternateEmail height="1rem" /> Dodaj email
                      </SecondaryBtn>
                      <SecondaryBtn onClick={() => {
                          if (show !== 'phone') {
                            setShow('phone');
                          } else {
                            setShow('');
                          }
                      }}>
                          <Call height="1rem" /> Dodaj telefon
                      </SecondaryBtn>
                  </ButtonWrapper>

                  {show === 'phone' &&
                    <AddContact
                      type="phone"
                      setRefetch={setRefetch}
                      refetch={refetch}
                      clientContact={clientContact}
                      contactValidation={phoneSchema}
                      stringValidation={stringSchema} />
                  }

                  {show === 'email' &&
                    <AddContact
                      type="email"
                      setRefetch={setRefetch}
                      refetch={refetch}
                      clientContact={clientContact}
                      contactValidation={mailSchema}
                      stringValidation={stringSchema} />
                  }
              </LoadingDataWrapper>
          </CommonColCard6>
          <CommonColCard6 cardTitle='Dobrowolna ankieta'>
              <p>Drodzy Klienci,</p>
              <p>
                  Dziękujemy, że jesteście z nami! Dbając o rozwój,
                  doskonalenie naszych usług, zwracamy się z prośbą
                  o pozostawienie opinii na temat usług świadczonych
                  przez naszą firmę. Za udzielenie rzetelnych odpowiedzi,
                  z góry dziękujemy!
              </p>
              <p>Czy są Państwo zadowoleni ze współpracy z naszą firmą?</p>
              <ButtonWrapper>
                  <PrimaryBtn onClick={() => {
                    window.open("https://www.google.com/search?q=korbank+opinie&oq=korbank+opinie&aqs=chrome.0.69i59j0i22i30l3j69i64j69i65j69i61.2360j0j4&sourceid=chrome&ie=UTF-8#lrd=0x470fc209399656e1:0x1c65aebda4f80603,1",
                      "_blank")
                  }}>
                      Tak
                  </PrimaryBtn>
                  <SecondaryBtn onClick={() => {
                    window.open("https://korbank.pl/pk-21/", "_blank")
                  }}>
                      Nie
                  </SecondaryBtn>
              </ButtonWrapper>
          </CommonColCard6>
      </MDBRow>
      <MDBRow className='gx-5 align-items-stretch'>
          <CommonColCard6 cardTitle='Dane logowania'>
              <MDBRow>
                  <CommonCol>
                      <LabelAndValueContent label='Login' value={clientLogin} />
                      <SecondaryBtn onClick={() => {
                          if (show !== 'password') {
                              setShow('password');
                          } else {
                              setShow('');
                          }
                      }}>
                          <Key height="1rem" /> Zmień hasło
                      </SecondaryBtn>
                      {show === 'password' &&
                          <ChangePassword validation={stringSchema}
                                          setShow={setShow}
                                          setFeedback={setFeedback}
                          />
                      }
                      <div>{feedback}</div>
                  </CommonCol>
                  <CommonCol>
                      {show === 'password' && <PasswordPolicyNote />}
                  </CommonCol>
              </MDBRow>
          </CommonColCard6>
      </MDBRow>
      </>
  )
}